module.exports = __webpack_public_path__ + "static/media/user.bbfa03f1.png";